import { render, staticRenderFns } from "./AuthFormPanel.vue?vue&type=template&id=0daad638"
import script from "./AuthFormPanel.vue?vue&type=script&lang=js"
export * from "./AuthFormPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports